const borderRadiuses = {
  BORDER_TOP_LEFT_RADIUS: 'border-top-left-radius',
  BORDER_TOP_RIGHT_RADIUS: 'border-top-right-radius',
  BORDER_BOTTOM_LEFT_RADIUS: 'border-bottom-left-radius',
  BORDER_BOTTOM_RIGHT_RADIUS: 'border-bottom-right-radius',
};

export default {
  ...borderRadiuses,
  BORDER: 'border',
  SHADOW: 'shadow',
};
